export default __webpack_public_path__ + "static/media/image2.8301be0c.jpeg";